import type { Locale } from '@/lib/i18n';
import type { SiteDictionary } from './types';
import { siteEn } from './en';
import { siteHi } from './hi';

/**
 * Site dictionaries for locales flagged `site: true` in locales.json. A locale
 * without one falls back to English — which is why only site-enabled locales
 * get full-site routes; a daily-only locale never renders these strings.
 */
const SITE_DICTIONARIES: Partial<Record<Locale, SiteDictionary>> = { en: siteEn, hi: siteHi };

export const getSiteDictionary = (locale: Locale): SiteDictionary => SITE_DICTIONARIES[locale] ?? siteEn;
export const hasSiteDictionary = (locale: Locale): boolean => locale in SITE_DICTIONARIES;
export type { SiteDictionary } from './types';
